import { StyleSheet } from 'react-native';
import { COLORS, FONTS } from '../../constants';

export const myBookingStyled = StyleSheet.create({
  container: {
    paddingHorizontal: 20,
  },
  bookingHeader: {
    fontSize: 14,
    letterSpacing: 1,
    textTransform: 'uppercase',
    color: '#fff',
    fontWeight: '500',
    fontFamily: FONTS.IowanOldStyleBTRoman,
    paddingRight: 20,
  },
  noDataWrapper: {
    flexDirection: 'row',
    justifyContent: 'center',
    paddingVertical: 20,
  },
  noDataText: {
    color: COLORS.GREEN,
    textTransform: 'uppercase',
    fontFamily: FONTS.AvenirMedium,
  },
});
